module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Regular-39ac0bd0636f86b392a66c811df672f6.ttf";